import React from 'react'
import { Card, Tooltip, Typography, Button } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import IntlMessages from '../../util/IntlMessages'
import YoutubeEmbed from '../youtube-embed'

interface MSBotSetupDrawerContentProps {
  onClose?: () => void
}

const { Paragraph } = Typography

export const MSBotSetupDrawerContent: React.FC<MSBotSetupDrawerContentProps> = ({ onClose }) => {
  return (
    <div className="ms-bot-setup-drawer-inner" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Card
        title={<IntlMessages id="components.setupMsBot.title" />}
        className="ms-bot-setup-drawer-card"
        extra={
          <Tooltip title={<IntlMessages id="app.close" />}>
            <Button type="text" icon={<CloseOutlined />} onClick={onClose} size="small" />
          </Tooltip>
        }
      >
        <Paragraph>
          <IntlMessages
            id="components.setupMsBot.followDirectLink"
            values={{
              // eslint-disable-next-line
              directLink: (...chunks) => (
                <a href="https://teams.microsoft.com/l/app/eab5463e-8168-40ee-887a-7ac78de1d266" target="_blank" rel="noopener noreferrer">
                  {chunks}
                </a>
              ),
            }}
          />
        </Paragraph>

        <Paragraph>
          <IntlMessages id="components.setupMsBot.inMSAppPreviewWindows" />
        </Paragraph>

        <div style={{ marginBottom: '16px' }}>
          <YoutubeEmbed embedId="vUbpc7-aEz0" title="Set up the Microsoft Teams bot and tabs" />
        </div>

        <Paragraph>
          <IntlMessages id="components.setupMsBot.setUpInMS" />
        </Paragraph>

        <Paragraph>
          <IntlMessages
            id="components.setupMsBot.stepByStep"
            values={{
              // eslint-disable-next-line
              helpDesk: (...chunks) => (
                <a href="https://vacationtracker.io/knowledge-base/" target="_blank" rel="noopener noreferrer">
                  {chunks}
                </a>
              ),
            }}
          />
        </Paragraph>
      </Card>
    </div>
  )
}
